// extracted by mini-css-extract-plugin
module.exports = {"container":"Calendar_container__1RwAf","weekdays":"Calendar_weekdays__8lyKT","calendarBody":"Calendar_calendarBody__3hJkB","error":"Calendar_error__2NQQl"};